import { render, staticRenderFns } from "./validation-form.vue?vue&type=template&id=553dbc12&scoped=true"
import script from "./validation-form.vue?vue&type=script&lang=js"
export * from "./validation-form.vue?vue&type=script&lang=js"
import style0 from "./validation-form.vue?vue&type=style&index=0&id=553dbc12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553dbc12",
  null
  
)

export default component.exports